//deps
import React, { memo, useCallback, useEffect, useState } from "react";

//styles
import {
    CommImgContainer,
    TurboPayCommsTooltip,
    TurboPayCommsTooltipContent,
} from "./styles/TurboPaymentWidgetComms.style";

//components
import OfferCommImg from "./OfferCommImg";

// defs
import { TurboPaymentCommsType, TurboCommsConfig, TurboPayOfferComms } from "@payment-ui/interfaces";

//constants
import { TURBO_PAYMENT_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";

import { getTurboPayWidgetCommsConfig } from "@payment-ui/helpers/TurboPayment";

interface TurboPaymentWidgetCommsProps {
    turboPaymentOfferComms: TurboPayOfferComms;
    hideEducationComms: boolean;
    primaryToolipDismissCallback?: VoidFunction;
    commsToShow: TurboPaymentCommsType | null;
    method?: string;
    isTurboV2?: boolean;
}

function TurboPaymentWidgetComms({
    turboPaymentOfferComms,
    hideEducationComms,
    primaryToolipDismissCallback,
    commsToShow,
    method,
    isTurboV2 = false,
}: TurboPaymentWidgetCommsProps) {
    const [commsType, setCommsType] = useState<TurboPaymentCommsType | null>(commsToShow);

    const hideComms = useCallback(() => {
        setCommsType(null);
        primaryToolipDismissCallback?.();
    }, [primaryToolipDismissCallback]);

    useEffect(() => {
        if (hideEducationComms && commsType === TurboPaymentCommsType.EDU_COMMS) {
            setCommsType(null);
        }
    }, [commsType, hideEducationComms]);

    const commsConfig: TurboCommsConfig | null = getTurboPayWidgetCommsConfig({
        commsType,
        offerCommsText: turboPaymentOfferComms?.toolTipText,
        method,
        isTurboV2,
    });

    if (!commsConfig) {
        return null;
    }

    const { text, commsDataTestId, textVariant } = commsConfig;

    return (
        <TurboPayCommsTooltip
            onClickClose={hideComms}
            closeIconDataTestId={TURBO_PAYMENT_WIDGET_DATA_TEST_IDS.COMMS_CLOSE}
            isTurboV2={isTurboV2}
        >
            <CommImgContainer as="div">
                {commsType === TurboPaymentCommsType.OFFER_COMMS && <OfferCommImg />}
            </CommImgContainer>
            <TurboPayCommsTooltipContent
                color="text_inverse_Highest_Emphasis"
                variant={textVariant}
                data-testid={commsDataTestId}
                tabIndex={0}
                commsType={commsType}
            >
                {text}
            </TurboPayCommsTooltipContent>
        </TurboPayCommsTooltip>
    );
}

export default memo(TurboPaymentWidgetComms);
